module.exports = __webpack_public_path__ + "img/11-submit.048b34dc.png";